import { storage } from '@repo/ui'
import { toast } from 'react-toastify'
import { googleLogout } from '@react-oauth/google'
import { signOut } from 'next-auth/react'

export const onHandleLogout = async () => {

    // Preserve currency preferences using the proper storage service
    const hadStoredPrefs = storage.hasStoredPrefs()
    const currencyPrefs = storage.getUserPrefs()
    const conversionRate = localStorage.getItem('conversionRate')

    localStorage.clear()

    // Restore currency preferences only if they existed before logout
    if (hadStoredPrefs) {
        storage.setUserPrefs(currencyPrefs)
    }

    // Restore conversion rate separately
    if (conversionRate) {
        localStorage.setItem('conversionRate', conversionRate)
    }

    toast.success('Successfully Logged out')
    googleLogout()

    // Call NextAuth signOut to clear HttpOnly cookies server-side
    // redirect: false prevents NextAuth's default redirect, we handle it ourselves
    await signOut({ redirect: false })

    // Redirect after server-side logout completes
    globalThis.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/stays`
}
